export default {"src":"/_next/static/media/Pelvic Inflammatory Disease.53f099b6.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};